import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdersService } from 'src/app/services/orders.service';

@Component({
  selector: 'app-user-orders',
  templateUrl: './user-orders.component.html',
  styleUrls: ['./user-orders.component.css']
})
export class UserOrdersComponent implements OnInit {

  orders = [];
  queryMismatch = false;

  constructor(private ordersService: OrdersService, private route: ActivatedRoute, private router: Router, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {

      const data = new FormData();
      data.append('mobile', params.mobile)

      this.ordersService.getAllOrdersAdAdmin(data).subscribe(result => {
        if (result.success) {
          this.orders = result.data;
        }
      }, error => {
        this.queryMismatch = true;
        this.snackBar.open(error.error.data, 'Dismiss', {
          duration: 3000
        });
      });
    }, error => {
      this.queryMismatch = true;
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  addOrder() {
    let mobile;
    this.route.queryParams.subscribe(params => {
      mobile = params.mobile;
    });
    this.router.navigate(['/admin/users/orders/create/'], { queryParams: { mobile: mobile } })
  }

  editOrder(ID: string) {
    let mobile;
    this.route.queryParams.subscribe(params => {
      mobile = params.mobile;
    });
    this.router.navigate(['/admin/users/orders/edit/'], { queryParams: { id: ID, mobile: mobile } });
  }
}
